import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { InfoCardType } from '@legacy/common-ui-models';
import type { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import {
  LinkField,
  RichTextField,
  TextField,
  JssModule,
} from '@sitecore-jss/sitecore-jss-angular';
import {
  TrackImpressionDirective,
  TrackLinkDirective,
} from '@analytics/events';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  GenericRichTextDirective,
  GenericLinkDirective,
} from '@core/jss-utils';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'wl-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: [
    './info-card.component.essent.scss',
    './info-card.component.ed.scss',
  ],
  standalone: true,
  imports: [
    TrackImpressionDirective,
    AutomationIdDirective,
    FaIconComponent,
    JssModule,
    GenericRichTextDirective,
    GenericLinkDirective,
    TrackLinkDirective,
    NgClass,
    TranslatePipe,
  ],
})
export class InfoCardComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() titleTranslationKey?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() message?: RichTextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() messageTranslationKey?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() messageTranslationParams?: any;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() automationId = 'info-card';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() border = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() type: InfoCardType = 'info';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: ComponentRendering | any;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() buttonLink?: LinkField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() buttonType: 'button' | 'button-outline' | 'link' = 'button';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() navigationExtras: NavigationExtras = {
    queryParamsHandling: 'merge',
  };
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackImpressionName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() mode: 'multiline' | 'single-line' = 'multiline';
  /**
   * This property does nothing for ED
   */
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() shadow = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() backgroundGrey = false;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hijackButton = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() buttonText?: string;
  @Output()
  buttonClick = new EventEmitter<void>();
}
